import { Link, useTrackCampaignOnLoad } from '@packages/shared';
import { useEffect } from 'react';
import { useAssignLinkTargetBasedOnBotStatus } from '../../../hooks/useAssignLinkTargetBasedOnBotStatus';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { LinkPromotion } from '../types';

export const PromotionAsLink = ({ data }: { data: LinkPromotion }): JSX.Element => {
  const { trackClick, trackDisplay } = useTrackCampaignOnLoad(data);
  const assignLinkTarget = useAssignLinkTargetBasedOnBotStatus();
  const finalLink = assignLinkTarget(data.linkReady);

  useEffect(() => {
    trackDisplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link
      href={finalLink}
      data-testid={PromotionBannerTestIds.asLink}
      noLinkStyle
      onClick={() => trackClick()}
    >
      {data.title}
    </Link>
  );
};
